/** @format */

import React from 'react'
import styled from 'styled-components'
import { _$, Tag } from '@king-design/react'
import { Descriptions, DescriptionItem } from 'src/components'
import { NodeFormValuesProps, renderSubScene } from './index'
import { geNodetDescription, InputTypeEnum, NodeTypeEnum } from '../../../container'
import AlarmReciverNew from 'src/components/AlarmReciver/new'
import AlarmCallBackNew from 'src/components/AlarmCallBack/new'
import TriggerCodeMirror from 'src/pages/EventOps/Trigger/components/RuleDrawer/TriggerCodeMirror'
interface ReadonlyProps {
  className?: string
  record: NodeFormValuesProps
  subSceneInfo: {
    name: string
    inputs: string[]
    outputs: string[]
  }
}

const Readonly: React.FC<ReadonlyProps> = ({ className, record, subSceneInfo }) => {
  if (!record) return null

  return (
    // 定时器没有输入输出参数
    <Descriptions columns={1} className={className}>
      <DescriptionItem label={_$('节点名称')}>{record?.name || '-'}</DescriptionItem>
      <DescriptionItem label={_$('节点类型')}>
        {_$(NodeTypeEnum[record?.type]) || '-'}
      </DescriptionItem>
      {/* 子场景 */}
      {record?.type === 'AUTOTASK_SUBSCENE' ? (
        <DescriptionItem label={_$('子场景')}>
          <p>{subSceneInfo?.name || '-'}</p>
          <div>{renderSubScene(subSceneInfo?.inputs, record?.inputs)}</div>
        </DescriptionItem>
      ) : null}
      {/* 输入参数 */}
      {record?.type !== 'AUTOTASK_TIMER' ? (
        <DescriptionItem label={record?.type === 'END' ? _$('流程输出') : _$('输入参数')}>
          <>
            <div className="input_items">
              {record?.inputs?.length
                ? record?.inputs?.map((item, index) => {
                    const { Type, Key, SourceNode, Value, SourceKey, Secret } = item
                    return (
                      <div className="ksc-space input_item" key={index}>
                        <p className="input_item_key">{Key}</p>
                        <span style={{ margin: '0 4px' }}>=</span>
                        <p className="input_item_type">{_$(InputTypeEnum[Type])}</p>
                        {SourceNode ? <p className="input_item_source_node">{SourceNode}</p> : null}
                        {SourceKey ? <p className="input_item_source_key">{SourceKey}</p> : null}
                        {Value ? (
                          <p className="input_item_value">
                            {Secret ? (
                              <>
                                <span>********</span>
                                <Tag type="primary">{_$('加密')}</Tag>
                              </>
                            ) : (
                              Value
                            )}
                          </p>
                        ) : null}
                      </div>
                    )
                  })
                : '-'}
            </div>
            <p className="input_item_description">
              {geNodetDescription(record?.type as keyof typeof NodeTypeEnum)}
            </p>
          </>
        </DescriptionItem>
      ) : null}
      {/* 数据处理 */}
      {record?.type === 'AUTOTASK_DISPLAY' ? (
        <DescriptionItem label={_$('数据处理')}>
          <TriggerCodeMirror readOnly scriptID={record?.scriptID} />
        </DescriptionItem>
      ) : null}
      {/* 定时器 */}
      {record?.type === 'AUTOTASK_TIMER' ? (
        <DescriptionItem label={_$('延迟时长')}>
          {record?.delay || '-'}
          {_$('秒')}
        </DescriptionItem>
      ) : null}
      {/* 人工介入 */}
      {record?.type === 'USERTASK' ? (
        <>
          <DescriptionItem label={_$('审批联系人')}>
            <AlarmReciverNew value={record?.userNotices} readonly />
          </DescriptionItem>
          <DescriptionItem label={_$('审批回调')}>
            <AlarmCallBackNew showCallbackType={false} value={record?.urlNotices} readonly />
          </DescriptionItem>
        </>
      ) : null}
      {/* 输出参数 */}
      {record?.type !== 'AUTOTASK_TIMER' ? (
        <DescriptionItem label={_$('输出参数')}>
          <div className="output_items">
            {record?.outputs?.length
              ? record?.outputs?.map((item, index) => {
                  return <Tag key={index}>{item}</Tag>
                })
              : '-'}
          </div>
          {record?.type === 'AUTOTASK_SUBSCENE' ? (
            <p className="input_item_description">
              {_$('子场景的输出参数为其所有结束节点输出的并集，实际运行中可能会有空值的情况。')}
            </p>
          ) : null}
        </DescriptionItem>
      ) : null}
    </Descriptions>
  )
}

export default styled(Readonly)`
  .input_items {
    .input_item {
      align-items: flex-start;
      margin-bottom: 8px;
      .input_item_value {
        flex: 1;
        word-break: break-all;
        .k-tag {
          margin-left: 4px;
        }
      }
      p {
        margin-bottom: 0;
      }
    }
  }
  .input_item_description {
    color: #999;
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .output_items {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .k-tag {
      margin-right: 4px;
    }
  }
`
